import Header from './components/Header';
import SliderSingle from './blocks/bloc_slider_single_type3';
import SliderMulti from './blocks/bloc_slider_multi';
import Accordion from './blocks/bloc_accordeon';
import Video from './components/Video';
import Form from './components/Form';
import Select from './components/Select';
import Map from './components/Map';
import Loader from './components/Loader';

const main = {
    init: function() {
        Header.init();
        SliderSingle.init();
        SliderMulti.init();
        Video.init();
        Accordion.init();
        Select.init();
        Form.init();
        Map.init();
        Loader.init();
    },
};

export default main;



// WEBPACK FOOTER //
// ./src/scripts/main.js